

















































































































































































































































































































































































import Vue from 'vue'

import {
  Find,
  Create,
  Get,
  Patch,
  Delete,
  TestConnection,
} from '@/api/collector'
import { Collector } from '../../../types/collector'

const { Splitpanes, Pane } = require('splitpanes')
import 'splitpanes/dist/splitpanes.css'

interface BTableItem {
  // eslint-disable-next-line
  [col: string]: any
}

export default Vue.extend({
  name: 'TableCollector',
  components: {
    Splitpanes,
    Pane,
  },
  data() {
    return {
      // ----------------------------------------------------------------------------------------
      // Options
      // ----------------------------------------------------------------------------------------
      optsDialect: [
        { value: 'mssql', text: 'Microsoft SQL Server' },
        { value: 'mysql', text: 'MySQL' },
        { value: 'pgsql', text: 'PostgreSQL' },
      ],
      /**
       * Retention policy expiration duration.
       *
       * Refer to influx retention policy for more information.
       */
      optsDuration: [
        { value: '1d', text: '1 day' },
        { value: '2d', text: '2 days' },
        { value: '4d', text: '4 days' },
        { value: '1w', text: '1 week' },
        { value: '2w', text: '2 weeks' },
        { value: '4w', text: '4 weeks' },
        { value: '8w', text: '8 weeks' },
        { value: '16w', text: '16 weeks' },
        { value: '32w', text: '32 weeks' },
        { value: '64w', text: '64 weeks' },
        { value: '128w', text: '128 weeks' },
        { value: '256w', text: '256 weeks' },
      ],

      /**
       * Retention policy sharding.
       *
       * Refer to influx retention policy for more information.
       */
      optsSharding: [
        { value: '1h', text: '1 hour' },
        { value: '1d', text: '1 day' },
        { value: '1w', text: '1 week' },
        { value: '2w', text: '2 weeks' },
        { value: '4w', text: '4 weeks' },
      ],

      items: [] as Collector[],
      newItem: {} as Collector,
      selectedItem: {} as Collector,
      selectedId: -1,

      testData: [] as BTableItem[],
    }
  },
  methods: {
    // ----------------------------------------------------------------------------------------
    // Data initialization
    // ----------------------------------------------------------------------------------------
    initNewItem() {
      this.newItem.id = 0
      this.newItem.name = ''
      this.newItem.dialect = 'mssql'
      this.newItem.connectionString =
        'user:pass@localhost:1443?database=datalog'
      this.newItem.table = 'tbl_datalog'
      this.newItem.limit = 100
      this.newItem.timeField = 'timestamp'
      this.newItem.timeFormat = 'YYYY-MM-DD HH:mm:ss'
      this.newItem.schedule = '*/5 * * * *'
      this.newItem.duration = '64w'
      this.newItem.shard = '1w'
      this.newItem.description = ''
    },
    // ----------------------------------------------------------------------------------------
    // Database operation
    // ----------------------------------------------------------------------------------------
    async create(c: Collector) {
      await Create(c)
    },
    async find(q?: Collector) {
      this.items = await Find(q)
    },
    async get(id: number) {
      return await Get(id)
    },

    async patch(id: number, c: Collector) {
      return await Patch(id, c)
    },

    async delete(id: number) {
      return await Delete(id)
    },

    // ----------------------------------------------------------------------------------------
    // Toolbars
    // ----------------------------------------------------------------------------------------
    onToolbarRefresh() {
      this.selectedId = -1
      this.find()
    },

    async onToolbarSave() {
      if (this.selectedId == -1) {
        if (this.newItem.name.length < 2) {
          return
        }
        await this.create(this.newItem)
        this.initNewItem()
        await this.find()
      } else {
        await this.patch(this.selectedId, this.selectedItem)
        await this.find()
      }
    },

    async onToolbarDelete() {
      if (this.selectedId == -1) {
        return
      }

      // eslint-disable-next-line
      ;(this as any).$refs.dialogDelete.show()
    },

    async onToolbarTest() {
      if (this.selectedId == -1) {
        return
      }
      this.testData = []
      try {
        const result = await TestConnection(this.selectedId)

        this.testData = result.data.map((da) => {
          const row: BTableItem = {}
          for (const i in result.fields) {
            row[result.fields[i].name] = da[i]
          }
          return row
        })

        // eslint-disable-next-line
        ;(this as any).$refs.dialogTestResult.show()
      } catch {
        //
      }
    },

    // ----------------------------------------------------------------------------------------
    // Dialogs
    // ----------------------------------------------------------------------------------------
    async onDialogDeleteOk() {
      await this.delete(this.selectedId)
      this.selectedId = -1
      await this.find()
    },

    // ----------------------------------------------------------------------------------------
    // Keyboard & mouse events
    // ----------------------------------------------------------------------------------------
    onRowClicked(c: Collector) {
      this.selectedId = c.id
      this.selectedItem = c
    },

    async onEnterKeyUp() {
      await this.patch(this.selectedId, this.selectedItem)
      await this.find()
    },

    async onNewDataEnterKeyUp() {
      await this.create(this.newItem)
      this.initNewItem()
      await this.find()
    },

    onNewDataClicked() {
      this.selectedId = -1
    },
  },

  watch: {
    selectedId: function(val) {
      this.$emit('onCollectorIdChanged', val)
    },
  },

  async created() {
    this.initNewItem()
    await this.find()
  },
})
